import React from 'react';
import { ImageIcon } from 'lucide-react';
import type { Project } from '../../data/portfolioProjects';
const accentHex = {
  orange: '#F5821F',
  green: '#7AC143',
  cyan: '#6E79E6',
  blue: '#2E3192'
} as const;
type Props = {
  project: Project;
  /** Featured cards render a taller frame. */
  size?: 'default' | 'large';
};

/**
 * Renders the approved browser capture for a project.
 *
 * TODO (content): every project currently has `image: null`, so this shows an explicitly
 * labeled placeholder. Once verified screenshots are supplied, set `image`/`alt` in
 * data/portfolioProjects.ts and the real capture renders here automatically.
 */
export function ProjectFrame({
  project,
  size = 'default'
}: Props) {
  const color = accentHex[project.accent];
  const ratio = size === 'large' ? 'aspect-[16/10]' : 'aspect-[16/9]';
  if (project.image) {
    return <div className={`relative w-full overflow-hidden border-b border-white/10 bg-navy-800 ${ratio}`} data-id="element-356" data-mp="3ebhfk3inofg4">
        <img src={project.image} alt={project.alt ?? `${project.name} website`} loading="lazy" decoding="async" className="h-full w-full object-cover object-top" data-id="element-357" data-mp="3kj8czrh91s1g" />
      </div>;
  }
  return <div className={`relative w-full overflow-hidden border-b border-white/10 bg-navy-800 ${ratio}`} data-id="element-358" data-mp="3ta8oqihdqnbj">
      <div className="absolute inset-0 bp-fine opacity-70" aria-hidden="true" data-id="element-359" data-mp="3pb8a7c5xq6uc" />
      <span className="absolute inset-x-0 top-0 h-[3px]" style={{
      backgroundColor: color
    }} aria-hidden="true" data-id="element-360" data-mp="31ldvsq5ywa7z" />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 px-4 text-center" data-id="element-361" data-mp="2wmkrnocklvkh">
        <ImageIcon className="h-5 w-5 text-white/30" aria-hidden="true" data-id="element-362" data-mp="3amluh9cebd2l" />
        <p className="text-[12px] font-semibold text-white/55" data-id="element-363" data-mp="35loacr7ts8yg">Screenshot pending</p>
        <p className="text-[12px] leading-snug text-white/35" data-id="element-364" data-mp="pua82wosxbro">Awaiting approved capture</p>
      </div>
    </div>;
}